var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 189,
    viewBox: "0 0 93 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tree-2_svg__a",
    d: "M0 0h93v189H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tree-2_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tree-2_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#tree-2_svg__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.391 72.776c2.02-3.335 3.228-7.527 3.228-12.086 0-7.474-3.236-13.973-8-17.297 1.989-4.297 3.132-9.32 3.132-14.687C83.751 12.852 73.783 0 61.486 0 49.19 0 39.222 12.852 39.222 28.706c0 .443.009.884.024 1.323a15.625 15.625 0 00-3.505-.398c-10.969 0-19.861 11.464-19.861 25.606 0 6.145 1.68 11.783 4.477 16.196C8.662 74.203 0 84.19 0 96.089c0 14.039 13.07 26.431 27.945 26.431 5.441 0 25.57.57 32.617.57C78.477 123.09 93 109.383 93 92.475c0-7.504-2.862-14.375-7.609-19.7z",
    fill: "#DBD8D3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBD8D3",
    cx: 57.965,
    cy: 79.438,
    rx: 17.039,
    ry: 14.383
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.643 172.617c-3.241-31.88-12.006-60.258-26.051-84.349l2.876-1.676c14.285 24.503 23.196 53.333 26.486 85.688l-3.311.337z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.98 189c-.012-.32-1.136-32.331.391-68.539 2.058-48.788 7.697-81.573 16.761-97.445l2.89 1.65C63.35 39.854 57.706 73.02 55.699 120.58c-1.522 36.08-.404 67.982-.392 68.3l-3.327.12z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.301 80.137l-2.424-2.281c.13-.137 12.948-13.891 16.959-28.467l3.209.883C71.812 65.657 58.85 79.552 58.3 80.137zM39.27 114.298c-.522-.282-12.85-7.022-18.37-18.06l1.237-.62c5.32 10.642 17.666 17.396 17.79 17.463l-.657 1.217z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.478 64.414l-.196-1.369.098.685-.1-.684c.067-.01 6.828-1.141 11.347-11.279l1.263.563c-4.851 10.885-12.106 12.04-12.412 12.084zM57.485 64.912c-10.273-9.884-2.875-33.73-2.555-34.741l1.318.417c-.075.24-7.46 24.038 2.196 33.327l-.959.997zM54.373 124.474l-.954-1c.094-.09 9.448-9.22 9.823-25.476l1.382.032c-.388 16.856-9.848 26.061-10.251 26.444z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBD8D3",
    cx: 27.03,
    cy: 85.738,
    rx: 19.136,
    ry: 16.153
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBD8D3",
    cx: 67.165,
    cy: 99.508,
    rx: 8.154,
    ry: 6.883
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBD8D3",
    transform: "rotate(-30.001 77.996 53.335)",
    cx: 77.996,
    cy: 53.335,
    rx: 5.272,
    ry: 9.365
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DBD8D3",
    cx: 62.716,
    cy: 26.297,
    rx: 13.99,
    ry: 11.809
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree2);
export default __webpack_public_path__ + "static/media/tree-2.94f1179fd4ddb13c20cc13dc6b3720ac.svg";
export { ForwardRef as ReactComponent };